<template>
  <div>
    <table class="mb-3 info_cot">
      <thead>
      <tr>
        <td class="prune-medium" rowspan="2" width="10%"><b>SIREN</b></td>
        <td class="bleu-ciel" rowspan="2" width="22%"><b>Raison Sociale</b></td>
        <td class="gris-medium" rowspan="2" width="22%"><b>Famille Produit</b></td>
        <td class="bleu-medium center" rowspan="2" width="12%"><b>Date<br>d'effet</b></td>
        <td class="vert-medium center" colspan="3" width="36%"><b>Nb Salariés</b></td>
      </tr>
      <tr>
        <td class="vert-clair right" width="12%"><b>Cadres</b></td>
        <td class="vert-clair right" width="12%"><b>Non-Cadres</b></td>
        <td class="vert-clair right" width="12%"><b>Autres</b></td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(element, key) in equipementContratDataTableX" :key="key">
        <td><b> {{ equipementContratDataSiren.siren }} </b></td>
        <td><b> {{ equipementContratDataSiren.raison_sociale }} </b></td>
        <td class="gris-clair"><b> {{ key || '-' }}</b></td>
        <td class="center">{{ getFormattedDate(element['DateEffet']) }}</td>
        <td class="right">{{ element['Cadre'] ? element['Cadre']['NbSal'] : '-' }}</td>
        <td class="right">{{ element['NonCadre'] ? element['NonCadre']['NbSal'] : '-' }}</td>
        <td class="right">{{ element['Autre'] ? element['Autre']['NbSal'] : '-' }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td class="prune-medium"><b>TOTAL</b></td>
        <td class="bleu-ciel"></td>
        <td class="gris-medium"></td>
        <td class="bleu-medium">&nbsp;</td>
        <td class="vert-clair center" colspan="3"><b>{{ equipementContratDataNbSalTotal }} salariés</b></td>
      </tr>
      </tfoot>
    </table>
    <div>
      <b-button type="enter" @click.prevent="extractGarantieFicheSiren" size="md" variant="primary">
        <i class="fa fa-search"></i> Générer CSV garantie
      </b-button>
    </div>
    <b-card class="mt-5" no-body>
      <div class="card-smallHeader card-header-action" v-b-toggle.collapse-tableau>
        <span><b>Détail par Établissements : </b></span>
        <div class="card-header-actions">
          <span class="when-opened"><i class="icon-arrow-down"></i></span>
          <span class="when-closed"><i class="icon-arrow-up"></i></span>
        </div>
      </div>
      <b-collapse id="collapse-tableau" class="p-3">
        <b-form-group>
          <b-form-checkbox-group v-model="selectedTypeContrat">
            <b-form-checkbox value="actifs" class="m-2">Contrats actifs</b-form-checkbox>
            <b-form-checkbox value="fermes" class="m-2">Contrats fermés</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <b-form>
          <b-row>
            <b-col sm="3">
              <b-form-group>
                <label for="nic"><strong>NIC</strong></label>
                <b-form-input type="text" id="nic" v-model="searchData.nic"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="famille_produit"><strong>Famille produit</strong></label>
                <b-form-input type="text" id="famille_produit" v-model="searchData.familleProduit"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-button type="enter" @click.prevent="searchByFilters" size="md" variant="primary">
                <i class="fa fa-search"></i> Rechercher
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <div v-if="dataTable.length === 0" class="mt-3">Aucun contrat n'a été trouvé</div>
        <table v-if="dataTable.length !== 0" class="mt-5 resultat">
          <thead>
          <tr>
            <th class="center" rowspan="2" style="width: 7%">NIC<br><span class="info_sup">*si Pb clé</span></th>
            <th id="nom_etab" rowspan="2" style="width: 20%" data-clos="25" data-actif="30">Nom Etablissement</th>
            <th rowspan="2" style="width: 15%">Famille<br>Produit</th>
            <th class="center" colspan="3" style="width: 12%">Effectif</th>
            <th class="center" rowspan="2" style="width: 9%">N° Contrats<br><span class="info_sup">ª si Pb Sous</span>
            </th>
            <th rowspan="2" style="width: 20%"><i>Codes-Produits</i></th>
            <th class="center" rowspan="2" style="width: 10%">Date Effet</th>
            <th v-if="isClosed" class="center" rowspan="2" style="width: 30%">Clôture<br>(Date-motif)</th>
          </tr>
          <tr>
            <th class="center" style="width: 4%"><i>C</i></th>
            <th class="center" style="width: 4%"><i>NC</i></th>
            <th class="center" style="width: 4%"><i>A</i></th>
          </tr>
          </thead>
          <component :is="dynamicComponent"/>
        </table>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import {formatDate} from "@/utils/communHelper";

  export default {
    name: "EquipementContratTab",
    data() {
      return {
        selectedTypeContrat: ['actifs'],
        dataTable: [],
        isClosed: false,
        searchData: {
          nic: '',
          familleProduit: '',
        },
        siren: '',
      }
    },
    props: [
      'equipementContratDataSiren',
      'equipementContratDataTableX',
      'equipementContratDataEtablissement',
      'equipementContratDataNbSalTotal',
    ],
    watch: {
      selectedTypeContrat() {
        this.isClosed = _.includes(this.selectedTypeContrat, 'fermes');
        this.$event.emit('changeTypeContrat', this.selectedTypeContrat);
      },
      equipementContratDataEtablissement(newVal, oldVal) {
        this.dataTable = newVal;
      }
    },
    created() {
      this.dataTable = this.equipementContratDataEtablissement;
      this.siren = this.$route.params.siren;
    },
    computed: {
      dynamicComponent: function () {
        let response = '';
        let data = _.groupBy(this.dataTable, 'nic');
        for (let index in data) {
          let groupe = [...data[index]];
          let nbLine = groupe.length;
          let firstLine = groupe.shift();
          response = response + `<tr style="border: 1px solid black">
                                  <td rowspan="${nbLine}" style="padding: 5px">${firstLine.nic}</td>
                                  <td rowspan="${nbLine}" style="border-left: 1px solid black; padding: 5px">${firstLine.raison_sociale}</td>
                                  <td style="border-left: 1px solid black; padding: 5px">${firstLine.lib_famille}</td>
                                  <td style="border-left: 1px solid black; padding: 5px">${firstLine.nb_sal_siret_cadre}</td>
                                  <td style="border-left: 1px solid black; padding: 5px">${firstLine.nb_sal_siret_non_cadre}</td>
                                  <td style="border-left: 1px solid black; padding: 5px">${firstLine.nb_sal_siret_autre}</td>
                                  <td style="border-left: 1px solid black; padding: 5px">${firstLine.num_contrat_coll}</td>
                                  <td style="border-left: 1px solid black; padding: 5px">${firstLine.codes_produits}</td>
                                  <td style="border-left: 1px solid black; padding: 5px">${firstLine.date_effet}</td>`;
          if (this.isClosed) {
            let cloture = '-';
            if (firstLine.date_clos === '0001-01-01' && firstLine.motif_clos === "") {
              cloture = "-";
            } else if (firstLine.date_clos === '0001-01-01' && firstLine.motif_clos !== "") {
              cloture = firstLine.motif_clos;
            } else {
              cloture = `${firstLine.date_clos} (${firstLine.motif_clos})`;
            }
            response = response + `<td style="border-left: 1px solid black; padding: 5px">${cloture}</td>`;
          }
          response = response + `</tr>`;
          for (let element of groupe) {
            response = response + `<tr><td style="border-left: 1px solid black; padding: 5px">${element.lib_famille} </td>
                                    <td style="border-left: 1px solid black; padding: 5px">${element.nb_sal_siret_cadre} </td>
                                    <td style="border-left: 1px solid black; padding: 5px">${element.nb_sal_siret_non_cadre} </td>
                                    <td style="border-left: 1px solid black; padding: 5px">${element.nb_sal_siret_autre} </td>
                                    <td style="border-left: 1px solid black; padding: 5px">${element.num_contrat_coll} </td>
                                    <td style="border-left: 1px solid black; padding: 5px">${element.codes_produits} </td>
                                    <td style="border-left: 1px solid black; padding: 5px">${element.date_effet} </td>
                                    <td v-if="this.isClosed" style="border-left: 1px solid black; padding: 5px">${element.nic} </td>`;
            if (this.isClosed) {
              let cloture = '-';
              if (element.date_clos === '0001-01-01' && element.motif_clos === "") {
                cloture = "-";
              } else if (element.date_clos === '0001-01-01' && element.motif_clos !== "") {
                cloture = element.motif_clos;
              } else {
                cloture = `${element.date_clos} (${element.motif_clos})`;
              }
              response = response + `<td style="border-left: 1px solid black; padding: 5px">${cloture}</td>`;
            }
            response = response + `</tr>`;
          }
        }
        return {
          template: '<tbody>' + response + '</tbody>',
        }
      }
    },
    methods: {
      searchByFilters() {
        if (this.searchData.nic === '' || this.searchData.familleProduit === '') {
          this.dataTable = this.equipementContratDataEtablissement;
        }
        if (this.searchData.nic !== '') {
          this.dataTable = _.filter(this.equipementContratDataEtablissement, (element) => element.nic.includes(this.searchData.nic));
        }
        if (this.searchData.familleProduit !== '') {
          this.dataTable = _.filter(this.equipementContratDataEtablissement, (element) => element.lib_famille.includes(this.searchData.familleProduit));
        }
        if (this.searchData.nic !== '' && this.searchData.familleProduit !== '') {
          this.dataTable = _.filter(this.equipementContratDataEtablissement, (element) => element.nic.includes(this.searchData.nic) && element.lib_famille.includes(this.searchData.familleProduit));
        }
      },
      extractGarantieFicheSiren() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceGestion/siren/extractGarantieFicheSiren/" + this.siren, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.downloadExportedFile(response, 'garantie_fiche_siren.xlsx');
          })
          .catch((error) => {
            this.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      },
      downloadExportedFile(response, filename) {
        let newBlob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100)

      },
      getFormattedDate(date) {
        return formatDate(date);
      },
    }
  }
</script>

<style scoped>

  .info_cot {
    border: 1px solid #464646;
  }

  .info_cot td {
    padding: 5px;
    border: 1px dotted #7F7E7E;
  }

  .vert-medium {
    background-color: #8FBC8F;
    color: #000000;
  }

  .gris-medium {
    background-color: #C8C8C8;
    color: #000000;
  }

  .bleu-medium {
    background-color: #8693BA;
    color: #000000;
  }

  .gris-clair {
    background-color: #EEEEEE;
    color: #000000;
  }

  .vert-clair {
    background-color: #CFE3CF;
    color: #000000;
  }

  .prune-medium {
    background-color: #cb6664;
    color: #000000;
  }

  .bleu-ciel {
    background-color: #b0bce0;
    color: #000000;
  }

  .center, td.center, th.center {
    text-align: center;
  }

  .right, td.right, th.right {
    text-align: right;
  }

  table.resultat th.center {
    text-align: center;
  }

  table.resultat th.right {
    text-align: right;
  }

  table.resultat tr td {
    border: none;
  }

  table.resultat {
    border: 1px solid black;
  }

  table.resultat tr th {
    border: 1px dotted #FFFFFF;
  }

  table.resultat tr td {
    border-left: 1px dotted #C1D9E3;
  }

  table.resultat tr td.dotted-top {
    border-top: 1px dotted #C1D9E3;
  }

  table.resultat tr td.solid-right {
    border-right: 1px solid #5B8B9F;
  }

  table.resultat tr td.solid-left {
    border-left: 1px solid #5B8B9F;
  }

  tr.pair td {
    background-color: #E3EBEF;
  }

  tr.impair td {
    background-color: #FFFFFF;
  }

  .info_sup {
    font-size: 0.9em;
    font-style: italic;
    font-weight: normal;
  }

  table.resultat th {
    border: 1px solid #FFF;
    background-color: #5B8B9F;
    text-align: left;
    padding: 3px;
    font-size: 13px;
    height: 20px;
    font-weight: bold;
    color: #ffffff;
  }

  table.resultat th.centre {
    text-align: center;
  }

</style>
